module.exports = __webpack_public_path__ + "static/media/DHL.87121365.svg";